/**
 * The V3 CMS (V2 API) returns a page's `content` as a block structure:
 *   { blocks: [{ id, class, type: 'text', content: '<html>' }, ...] }
 * but this Nuxt 2 frontend was built for the V1 contract where `content` is a
 * raw HTML string rendered via v-html. Without flattening, the whole object gets
 * serialized and shown as JSON on the page.
 *
 * Flatten the block structure back to an HTML string (concatenating each block's
 * HTML). Passes through strings unchanged so V1-shaped data still works.
 */
export function blocksToHtml(content) {
  if (typeof content === 'string') return content
  if (content && Array.isArray(content.blocks)) {
    return content.blocks
      .map((block) =>
        block && typeof block.content === 'string' ? block.content : ''
      )
      .join('')
  }
  if (content == null) return ''
  return String(content)
}
